var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-map-container"}},[_c('div',{style:(("height:" + _vm.height + "px;width:" + _vm.width + "px;")),attrs:{"id":"xhn-map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }